import React, { useState } from 'react';
import { Checkbox, FormControl, MenuItem, TextField } from '@mui/material';
const ChartSelect = ({ chartAttributes, selectedChartAttributes, setSelectedChartAttributes, chartType, setChartType }) => {

    const chartTypes = ['bar','pie']

    const handleSelect = (e) => {
        setSelectedChartAttributes(e.target.value)
    }

    const handleSelectChart = (e) => {
        setChartType(e.target.value)
    }
    return <>
        <FormControl fullWidth style={{ paddingBottom: '10px' }}>
            <TextField
                value={chartType}
                label="Select chart type"
                select
                onChange={handleSelectChart}
                SelectProps={
                    {
                        value: chartType
                    }
                }
                >
                    {chartTypes?.map((chart)=> (
                    <MenuItem key={chart} value={chart}>
                        {chart}
                    </MenuItem>
                ))}
            </TextField>
        </FormControl>
        <FormControl fullWidth>
            <TextField
                value={selectedChartAttributes}
                label="Select chart attributes"
                select
                onChange={handleSelect}
                SelectProps={
                    {
                        value: selectedChartAttributes,
                        multiple: true,
                        renderValue: (selected) => selected.map((x) => x).join(', ')
                    }
                }
                >
                    {chartAttributes?.map((attribute)=> (
                    <MenuItem key={attribute} value={attribute}>
                        <Checkbox
                            checked={selectedChartAttributes?.findIndex((item) => item === attribute) >= 0}
                        />
                        {attribute}
                    </MenuItem>
                ))}
                </TextField>
        </FormControl>
    </>
}

export default ChartSelect;